import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private _menuActive = new BehaviorSubject<any>(null);
  menuActive$ = this._menuActive.asObservable();

  setMenu(data: any) {
    this._menuActive.next(data);
  }
}